import Layout from '@/components/common/Layout.vue';
import BlankLayout from '@/components/BlankLayout/BlankLayout.vue';

// 布局路由（作为所有页面的父路由）
export const layoutRoutes = [
  // 1. 默认布局（带 Header + 子路由 Tab）
  {
    path: '/',
    name: 'DefaultLayout',
    component: Layout,
    meta: { requiresAuth: false },
    children: []
  },
  // 2. 空白布局（无 Header、无样式）
  {
    path: '/blank',
    name: 'BlankLayout',
    component: BlankLayout,
    meta: { requiresAuth: false },
    children: []
  },
  // 3. 官网路由
  {
    path: '/website',
    name: 'WebsiteLayout',
    component: () => import('../views/website/components/layout.vue'),
    meta: { requiresAuth: false },
    children: []
  }
];